import { createFileRoute } from '@tanstack/react-router';

import { AgencySetup } from '@/components/agency/setup/agency-setup';
import { loadNamespaces } from '@/lib/i18n/i18n';

export const Route = createFileRoute('/_authenticated/agency/setup')({
  loader: () => loadNamespaces('agency', 'auth', 'onboarding', 'settings'),
  staticData: { title: 'route.agency_setup.title', hideAppShell: true },
  component: AgencySetup,
});
